import { render, staticRenderFns } from "./UserEditTabPreferences.vue?vue&type=template&id=3c9412de&scoped=true"
import script from "./UserEditTabPreferences.vue?vue&type=script&lang=js"
export * from "./UserEditTabPreferences.vue?vue&type=script&lang=js"
import style0 from "./UserEditTabPreferences.vue?vue&type=style&index=0&id=3c9412de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9412de",
  null
  
)

export default component.exports